module.exports=function(scope){ return `<!-- Liveness passed -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The 3D FaceMap evaluated and Liveness was proven."
    },
    "data": {
        "errorMessageFromZoomServer": null,
        "errorStatusFromZoomServer": 0,
        "glasses": false,
        "isLowQuality": false,
        "isReplayFaceMap": true,
        "livenessStatus": 0,
    }
}

<!-- Liveness was unsuccessful -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The 3D FaceMap evaluated and Liveness was not proven. The developer should prompt the user with retry guidance as demonstrated in the Device SDK Sample Apps."
    },
    "data": {
        "errorMessageFromZoomServer": null,
        "errorStatusFromZoomServer": 0,
        "glasses": false,
        "isLowQuality": false,
        "isReplayFaceMap": true,
        "livenessStatus": 1
    }
}

<!-- NOTE: Server REST API provides additional properties for this end point -->
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/liveness.json.tpl